import type { ConceptDef } from '../types';

export const patternCompletion: ConceptDef = {
  kind: 'tileMatch',
  id: 'pattern-completion',
  label: 'Pattern Completion',
  category: 'Sequencing',
  description: 'Hear a pattern; tap the item that comes next.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Red, blue, red, blue. What comes next?', answer: '🟥 red' },
      { say: 'A, B, A, B. What comes next?', answer: 'A' },
      { say: 'One, two, three. What comes next?', answer: '4' },
      { say: 'Circle, square, circle, square. What comes next?', answer: '⭕ circle' },
      { say: 'Up, down, up, down. What comes next?', answer: '⬆ up' },
    ],
  },
};
